import { useLayoutEffect, useState } from 'react';
import style from '../HeaderButtons.module.scss';

export const useHeaderColorScheme = headerColorScheme => {
  const [headerBtnStyle, setHeaderBtnStyle] = useState(style.headerBar__button);

  useLayoutEffect(() => {
    if (headerColorScheme === '' || headerColorScheme === 'blackOnTransparent') {
      setHeaderBtnStyle(`${style.headerBar__button + ' ' + style.headerBarWhite__button}`);
    } else {
      setHeaderBtnStyle(style.headerBar__button);
    }
  }, [headerColorScheme]);

  return headerBtnStyle;
};
